module.exports = __webpack_public_path__ + "static/media/icon-ANALYTICS.52d93bd0.png";